<template>
    <ClientList></ClientList>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const ClientList = defineAsyncComponent(() =>
    import("../../components/Sales/ClientList.vue")
);
export default {
    name: "ClientListPage", //The name you are in should not equal the name of the component you are importing.
    components: { ClientList, AuthLayout },
};
</script>

<style></style>
